'use strict';

import controller from './controller';
import formTeamModule from './form-team';

const MODULE_NAME = 'daupler.entities.ug';

var app = angular.module(MODULE_NAME, [
	formTeamModule,
]);
app.controller('UgCtrl', controller);

export default MODULE_NAME;
